module.exports = __webpack_public_path__ + "static/op-ae094e1e8efb2c2870665cc15f75fad6.jpg";